import * as yup from "yup";
import { DateTime } from "luxon";
import type { CartaoCredito } from "../types/assinatura";

const cartaoCreditoSchema: yup.ObjectSchema<CartaoCredito> = yup.object({
  numero: yup
    .string()
    .matches(/\d{16}/, "Número inválido")
    .required("Número obrigatório"),
  titular: yup
    .string()
    .max(26, "Máx 26 caracteres")
    .matches(/(\w|\s){1,26}/i, "Nome inválido")
    .required("Nome obrigatório")
    .trim(),
  validade: yup
    .string()
    .test(
      "valid-date",
      "Data inválida",
      (value) => DateTime.fromFormat(value, "MMyy").startOf("month").isValid
    )
    .test(
      "expired-date",
      "Cartão expirado",
      (value) =>
        DateTime.fromFormat(value, "MMyy").startOf("month") >=
        DateTime.now().startOf("month")
    )
    .required("Validade obrigatória"),
  cvv: yup
    .string()
    .matches(/\d{3}/, "CVV inválido")
    .required("CVV obrigatório"),
});

export default cartaoCreditoSchema;
